import styled, { css } from 'styled-components/macro';

import { large, medium } from 'styles/breakpoints';
import { error, eyebrow, heading, input, paragraph } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const Heading = styled.h1`
  ${heading}

  margin-bottom: 71px;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}

  ${large`
    margin-bottom: 55px;
  `}
`;

export const SummaryDetails = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 26px;
`;

export const SummaryItems = styled.div`
  list-style: none;
  padding: 0;
  text-align: left;
`;

export const SalesPerson = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin: 0 0 12px;
`;

export const faceStyles = css`
  border-radius: 100%;
  height: 74px;
  margin: 0 13px 0 0;
  width: 74px;

  ${medium`
    height: 96px;
    width: 96px;
  `}
`;

export const Name = styled.h2`
  ${eyebrow}

  margin: 0;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
`;

export const Title = styled.p`
  ${paragraph}

  margin: 0;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
`;

export const SummaryItem = styled.p.attrs({ role: 'button' })`
  ${input}

  align-items: center;
  cursor: pointer;
  display: flex;
  line-height: 24px;
  margin: 0 0 7px 57px;
  position: relative;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}

  ${medium`
    margin-left: 79px;
  `}
`;

export const summaryItemImageStyles = css`
  height: 24px;
  margin-right: 10px;
  width: 21px;

  ${({ theme }: IWithThemeProps) => `
    [data-svg-class='InputError-stroke'] {
      stroke: ${theme.bottomBackgroundColor};
    }
  `}
`;

export const navTooltipStyles = css`
  left: 50%;
  top: 96px;
  transform: translateX(-50%);
`;

export const errorTooltipStyles = css`
  ${error}

  bottom: 20px;
  left: -95px;
  width: 310px;

  ${large`
    left: -157px;
    width: 442px;
  `}
`;
